import { OrderMissionEntity } from '@src/core/features/order/entities/order-mission-entity';

/** Which map tree to mount for the current selection. */
export type DronesMapMode = 'main' | 'enroute';

/**
 * Resolve mission id for map route + sidebar panels.
 * URL (`routeMissionIdFromUrl`) is the cross-navigation source; drone/order fill gaps.
 */
export function resolveEffectiveMissionId(args: {
  isSelectedIdle: boolean;
  trustedDroneMissionId?: string;
  orderMissionIdForRoute?: string;
  routeMissionIdFromUrl?: string | null;
}): string | null {
  const { isSelectedIdle, trustedDroneMissionId, orderMissionIdForRoute, routeMissionIdFromUrl } =
    args;

  if (isSelectedIdle) return orderMissionIdForRoute ?? null;

  return (
    trustedDroneMissionId ||
    orderMissionIdForRoute ||
    routeMissionIdFromUrl ||
    null
  );
}

export function missionDataMatchesDrone(
  mission: OrderMissionEntity | undefined,
  missionId: string | null,
  selectedSerial: string | null | undefined,
): boolean {
  if (!missionId || mission?.missionId !== missionId) return false;
  const droneSerial = mission.drone?.serialNumber;
  return !droneSerial || !selectedSerial || droneSerial === selectedSerial;
}

export function resolveDronesMapMode(args: {
  effectiveMissionId: string | null;
  hasSelectedDrone: boolean;
  isFreeFlight: boolean;
  missionCacheMatches: boolean;
}): DronesMapMode {
  const { effectiveMissionId, hasSelectedDrone, isFreeFlight, missionCacheMatches } = args;
  if (!effectiveMissionId || !hasSelectedDrone || isFreeFlight || !missionCacheMatches) {
    return 'main';
  }
  return 'enroute';
}
